export default {
  PART_DIMENSION_Z: null,
  PART_DIMENSION_X: null,
  PART_DIMENSION_Y: null,
  PART_VOLUME: null,
  MODEL_AMOUNT: null,
  AREA: null,
  SHOP_PRICE: null,
};
